// Desktop sidebar open/close for pages other than the homepage. Toggles data-sidebar-open on <body>;
// config/styles.css (.sidebar-toggle rules) slides #site-sidebar in and out at lg+.
// Escape, the close button and a click on the backdrop close it; focus returns to the open button.
class SSidebarToggle extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.openButton = this.querySelector('[data-sidebar-open-button]');
    this.closeButton = document.querySelector('[data-sidebar-close-button]');
    this.sidebar = document.getElementById('site-sidebar');
    this.openButton?.addEventListener('click', () => this.#setOpen(true), { signal });
    this.closeButton?.addEventListener('click', () => this.#setOpen(false, true), { signal });
    this.querySelector('[data-sidebar-backdrop]')?.addEventListener('click', () => this.#setOpen(false, true), { signal });
    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && document.body.hasAttribute('data-sidebar-open')) this.#setOpen(false, true);
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #setOpen(open, returnFocus = false) {
    document.body.toggleAttribute('data-sidebar-open', open);
    this.openButton?.setAttribute('aria-expanded', String(open));
    this.closeButton?.setAttribute('aria-expanded', String(open));
    if (open) {
      requestAnimationFrame(() => this.closeButton?.focus());
    } else if (returnFocus) {
      this.openButton?.focus();
    }
  }
}

if (!customElements.get('s-sidebar-toggle')) {
  customElements.define('s-sidebar-toggle', SSidebarToggle);
}
